import { Feature } from "./feature";

export class PlanType {
    id: string;
    name: string;
    seoName: string;
    description: string;
    requests: number;
    details: Array<string>;
    price: number;
    commission: number;
    monetizationType: number;
    period: number;
    order: number;
    active: boolean;
    newDetail: string;
    selectable: boolean
    selected: boolean
    featureId: string
    features: Array<Feature>
}
